import React from 'react';
import { Calendar, Clock, Shield, X, Pencil, User } from 'lucide-react';
import { getJobDisplayName } from '../../../../utils/maintenanceJobHelpers';

const MaintenanceCheckHeader = ({
  job,
  equipmentImage,
  status,
  onBack,
  formatDate,
  onEdit,  // FT-186: Edit callback for custom jobs
  isCustomJob = false  // FT-186: Flag to show edit button
}) => {
  // FT-186 DEBUG: Verify props are received
  console.log('FT-186 HEADER RENDER', { isCustomJob, onEdit: !!onEdit, jobCustom: job?.custom, jobType: job?.type, jobId: job?.id, jobCategory: job?.category });

  const StatusIcon = status.icon;

  return (
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-start gap-3 sm:gap-4">
          {/* Close button */}
          <button
            onClick={onBack}
            className="mt-0.5 p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
            title="Close"
          >
            <X className="h-5 w-5" />
          </button>

          {/* Equipment thumbnail — display-only per FT-346. Upload path moved
              to the dedicated Evidence Photos section (PhotoAttachment). */}
          <div className="flex-shrink-0">
            <img
              src={equipmentImage}
              alt={getJobDisplayName(job)}
              className="w-12 h-12 sm:w-16 sm:h-16 object-cover rounded-lg"
            />
          </div>
          
          {/* Title and info */}
          <div className="flex-1">
            <div className="flex items-start justify-between">
              <div>
                <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900">
                  {getJobDisplayName(job)}
                </h1>
                <div className="flex flex-wrap items-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-500 mt-1">
                  <span className="flex items-center">
                    <Calendar className="h-3 w-3 mr-1" />
                    Every {job.interval} {job.unit}
                  </span>
                  <span className="flex items-center">
                    <Clock className="h-3 w-3 mr-1" />
                    Last: {formatDate(job.lastCompleted)}
                  </span>
                  {/* FT-183: Assigned to */}
                  {job.assignedTo && (
                    <span className="flex items-center">
                      <User className="h-3 w-3 mr-1" />
                      {job.assignedTo}
                    </span>
                  )}
                  {job.regulation && (
                    <span className="flex items-center">
                      <Shield className="h-3 w-3 mr-1" />
                      {job.regulation}
                    </span>
                  )}
                </div>
              </div>
              
              {/* FT-186: Edit button for custom jobs + Status badge */}
              <div className="flex items-center gap-2">
                {onEdit && (
                  <button
                    onClick={() => onEdit(job)}
                    className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium text-cyan-700 bg-cyan-50 hover:bg-cyan-100 border border-cyan-200 transition-colors"
                    title="Edit Job"
                  >
                    <Pencil className="h-3 w-3 mr-1" />
                    <span className="hidden sm:inline">Edit</span>
                  </button>
                )}
                {/* Status badge - smaller on mobile */}
                <div className={`inline-flex items-center px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full text-[10px] sm:text-xs font-medium border ${status.color}`}>
                  <StatusIcon className="h-2.5 sm:h-3 w-2.5 sm:w-3 mr-0.5 sm:mr-1" />
                  <span className="hidden sm:inline">{status.text}</span>
                  <span className="sm:hidden">{job.status === 'overdue' ? `${Math.abs(job.daysUntilDue)}d` : job.status === 'due_soon' ? `${job.daysUntilDue}d` : '✓'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceCheckHeader;